import orderIcon from 'images/common/order.svg'
import leftArrow from 'images/common/leftArrowTeal.svg'
import './headerView.scss'
import { useProductOrderContext } from 'components/product-order-popup/context'
import { Cart } from '../cart/Cart'
import { useCallback } from 'react'

interface Props {
  title: string
  subtitle?: string
  backClick?: () => void
}

export const HeaderView = ({ title, subtitle, backClick }: Props) => {
  const { goBack, position, isMHT, cartItems } = useProductOrderContext()

  const onBackClick = useCallback(() => {
    if (backClick) backClick()
    else goBack()
  }, [backClick, goBack])
  return (
    <div className='header-view-wrapper'>
      <div className='header-view-container'>
        {position.currentIndex > 0 ?
          <img
            role='presentation'
            src={leftArrow}
            alt='Left arrow icon'
            className='product-selection-view-left-arrow'
            onClick={onBackClick}
          />
        : <img className='header-icon' src={orderIcon} alt='Order icon' />}
        <div className='header-text-container'>
          <div id='title' className='header-text'>
            {title}
          </div>
          <div className='subtitle-text'>{subtitle}</div>
        </div>
      </div>
      {isMHT &&
        position.currentIndex > 0 &&
        position.currentIndex < position.totalSteps - 3 &&
        cartItems.length > 0 ? <Cart /> : null}
    </div>
  )
}
